import { mergeStyles, Stack, Text } from '@fluentui/react';

import ContentBox from '../../ContentBox';
import FormList from '../../Forms/List/FormList';

export default () => {
  return (
    <div className={contentStyles}>
      <Stack tokens={{ childrenGap: 10 }}>
        <Text variant="xxLarge">Yeni Fatura</Text>
        <ContentBox>
          <FormList
            focusIconKey="PageAdd"
            filter={(docData) => !docData.invoice}
          />
        </ContentBox>
      </Stack>
    </div>
  );
};

const contentStyles = mergeStyles({
  marginTop: "16px",
  marginLeft: "50%",
  width: "50%",
  transform: "translateX(-50%)",
});
